export default __webpack_public_path__ + "static/media/061.6212aac6.jpg";